import { valibotResolver } from '@hookform/resolvers/valibot';
import { nonEmpty, object, pipe, string, trim } from 'valibot';

import type { IGPSTracker } from '@model/gpsTracker';

export const GPS_TRACKER_FIELDS = {
  MODEL: 'model',
  IMEI: 'imei',
  ICCID: 'iccid',
  SERIAL_NUMBER: 'serialNumber',
};

export interface IFormGPSTracker {
  model: string;
  imei: string;
  iccid: string;
  serialNumber: string;
}

export const schemaGPSTracker = valibotResolver(
  object({
    [GPS_TRACKER_FIELDS.MODEL]: pipe(string(), trim(), nonEmpty('This field is required.')),
    [GPS_TRACKER_FIELDS.SERIAL_NUMBER]: pipe(string(), trim(), nonEmpty('This field is required.')),
    [GPS_TRACKER_FIELDS.IMEI]: pipe(string(), trim()),
    [GPS_TRACKER_FIELDS.ICCID]: pipe(string(), trim()),
  }),
);

export const gpsTrackerDefaultValues = (gpsTracker: IGPSTracker) => {
  return {
    [GPS_TRACKER_FIELDS.MODEL]: gpsTracker?.model || '',
    [GPS_TRACKER_FIELDS.SERIAL_NUMBER]: gpsTracker?.serialNumber || '',
    [GPS_TRACKER_FIELDS.IMEI]: gpsTracker?.imei || '',
    [GPS_TRACKER_FIELDS.ICCID]: gpsTracker?.iccid || '',
  };
};
